import useAdjustFontSizes from '@/hooks/useAdjustFontSizes';
import { useRef, useState } from "react";

const VideoItem = ({ video, index, isActive, onMouseEnter, setVideoRef }) => {
    const titleRef = useRef(null);

    const elements = {
        title: { ref: titleRef, maxFontSize: 14, maxHeight: 65 },
    };

    const [fontSizes, setFontSizes] = useState({
        title: 14,
    });


    useAdjustFontSizes(elements, [video.text], setFontSizes);

    return (
        <div className="flex flex-col shadow-slideShadow bg-[#F6F6F6]">
            <div
                ref={titleRef}
                className="text-center italic text-[#2b2b2b] opacity-[0.88] font-medium h-[65px] pt-2 px-2"
                dangerouslySetInnerHTML={{ __html: video.text }}
                style={{
                    fontSize: `${fontSizes.title}px`,
                    lineHeight: `${fontSizes.title}px`,
                }}
            />
            <video
                ref={(el) => setVideoRef(index, el)}
                data-index={index}
                src={video.videoUrl}
                muted
                loop
                playsInline
                className="w-full h-auto"
                onMouseEnter={() => onMouseEnter(index)}
            />
            {/* <div className="text-[#2b2b2b] opacity-[0.88] justify-center text-center h-8 flex items-center font-semibold">
                {video.title}
            </div> */}
        </div>
    );
};

export default VideoItem;